import Vue from 'vue'
import { URL_ORGANIZATION_DRAFT } from '@/constants/urls.js'
import { BANK_ACCOUNTS_DRAFTS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [BANK_ACCOUNTS_DRAFTS.STATE.BANK_ACCOUNTS]: null
}

const actions = {
  async [BANK_ACCOUNTS_DRAFTS.ACTIONS.GET_BANK_ACCOUNTS_DRAFTS] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}/bankAccounts?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BANK_ACCOUNTS_DRAFTS.MUTATIONS.GET_BANK_ACCOUNTS_DRAFTS, resp.data)
  },
  async [BANK_ACCOUNTS_DRAFTS.ACTIONS.DELETE_BANK_ACCOUNT_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}/bankAccounts/${model.bankAccountId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BANK_ACCOUNTS_DRAFTS.ACTIONS.CREATE_BANK_ACCOUNT_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFT}/bankAccounts/${model.accountType}`,
      model: model.bankAccount
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BANK_ACCOUNTS_DRAFTS.ACTIONS.CLEAR_BANK_ACCOUNTS_DRAFTS] ({ commit }) {
    commit(BANK_ACCOUNTS_DRAFTS.MUTATIONS.CLEAR_BANK_ACCOUNTS_DRAFTS)
  }
}

const mutations = {
  [BANK_ACCOUNTS_DRAFTS.MUTATIONS.GET_BANK_ACCOUNTS_DRAFTS] (state, bankAccounts) {
    state[BANK_ACCOUNTS_DRAFTS.STATE.BANK_ACCOUNTS] = bankAccounts
  },
  [BANK_ACCOUNTS_DRAFTS.MUTATIONS.CLEAR_BANK_ACCOUNTS_DRAFTS] (state) {
    state[BANK_ACCOUNTS_DRAFTS.STATE.BANK_ACCOUNTS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
